import React from 'react';
import { StyledBuyPackage } from './index.style';
import NewPricingModelV3 from '../NewPricingModelV3';

const BuyPackage = () => {
  const renderScreenPackage = () => <NewPricingModelV3 />;
  return <StyledBuyPackage>{renderScreenPackage()}</StyledBuyPackage>;
};

export default BuyPackage;
